import type { FunctionalComponent } from 'preact'

export const Terms: FunctionalComponent<{
  btn?: string
}> = props => {
  return (
    <>
      Нажимая «{props.btn ?? 'Продолжить'}», вы принимаете{' '}
      <a
        target='_blank'
        href='/docs/privacy_policy.html'
      >
        политику обработки персональных данных
      </a>
    </>
  )
}
